import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;

const userService = {
  // Get all users with pagination and filters
  getUsers: async (params: {
    page?: number;
    limit?: number;
    status?: string;
    role_id?: number;
    search?: string;
  } = {}) => {
    const token = localStorage.getItem('access_token');
    console.log('UserService - Token:', token ? 'Present' : 'Missing');
    console.log('UserService - API URL:', API_BASE_URL);
    
    const response = await axios.get(`${API_BASE_URL}/users`, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  // Get user statistics
  getUserStats: async () => {
    const response = await axios.get(`${API_BASE_URL}/users/stats`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
    });
    return response.data;
  },

  // Get user by ID
  getUserById: async (id: number) => {
    const response = await axios.get(`${API_BASE_URL}/users/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
    });
    return response.data;
  },

  // Create new user
  createUser: async (userData: {
    username: string;
    email: string;
    password: string;
    first_name: string;
    last_name: string;
    role_id: number;
  }) => {
    const response = await axios.post(`${API_BASE_URL}/users`, userData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  },

  // Update user
  updateUser: async (id: number, userData: {
    username?: string;
    email?: string;
    first_name?: string;
    last_name?: string;
    role_id?: number;
    status?: string;
  }) => {
    const response = await axios.put(`${API_BASE_URL}/users/${id}`, userData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  },

  // Delete user (soft delete)
  deleteUser: async (id: number) => {
    const response = await axios.delete(`${API_BASE_URL}/users/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
    });
    return response.data;
  },

  // Toggle user status
  toggleUserStatus: async (id: number, status: 'active' | 'inactive' | 'suspended') => {
    const response = await axios.put(`${API_BASE_URL}/users/${id}/status`, { status }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  },

  // Get roles (assuming this endpoint exists)
  getRoles: async () => {
    const token = localStorage.getItem('access_token');
    console.log('UserService - Getting roles with token:', token ? 'Present' : 'Missing');
    
    const response = await axios.get(`${API_BASE_URL}/roles`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },
};

export default userService;
